const ROUTES_MAP: Record<string, string | null> = {
  ['familyNavigator:addFamily']: '/signup/family/select-age',
  ['mapNavigator:map']: '/map',
  ['gameHomeNavigator:gameHome']: '/',
  ['gameHomeNavigator:howToPlay']: '/how-to-play',
  ['gameHomeNavigator:events']: '/events',
  ['gameHomeNavigator:weeklyThemeDescription']: null,
  ['dashboardNavigator:dashboard']: '/dashboard',
  ['dashboardNavigator:locationHistory']: null,
  ['dashboardNavigator:awards']: '/awards',
  ['dashboardNavigator:gems']: null,
  ['dashboardNavigator:createTeam']: '/signup/create-team',
  ['dashboardNavigator:leaderboardsV2']: '/team-leaderboard',
  ['leaderboardNavigator:leaderboards']: '/leaderboards',
  ['leaderboardNavigator:followPlayer']: null,
  ['dashboardNavigator:settingsNavigator']: '/account',
  ['settingsNavigator:profileDetails']: null,
  ['settingsNavigator:joinTeam']: null,
  ['settingsNavigator:privacyPolicy']: '/privacy',
  ['settingsNavigator:termsAndConditions']: '/terms-and-conditions',
  ['messageCenter:messages']: '/messages',
  ['messageCenter:teamMessage']: null,
}

export function getInternalRoute(path: string): string | null {
  return ROUTES_MAP[path] || null
}
